Vue.component('user-faction', {
  template: templates.userFaction,
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      model: {
        id: null,
        factions: [],
        hasFaction: false,
        factionMembers: [],
        settings: {},
        factionStats: {},
        userFactionHistory: [],
        userTwitchInfo: {},
        loading: false,
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.getSettings();
    c.getUserLevel();

  },

  beforeDestroy() {
    const c = this;
    document.removeEventListener('click', c.handleClickOutside);
  },
  methods: {
    get() {
      const c = this;

      let data = {};

      factionService.getUserFaction()
        .then(function (response) {
       
          for (let d of response.data) {
            d.image = `${root}/images/faction/${d.id}.png`;
            d.video = `/videos/keys/${d.id}.webm`;
            data[`${d.id}`] = d;
          }
          c.model.factions = data;

          const factionCount = Object.keys(data).length;
          if(factionCount === 1){
            c.$root.$emit('openFaction', response.data[0]);
            c.model.hasFaction = true;
            c.getFactionTeam(response.data[0].id);
            c.model.factionName = response.data[0].name;
            c.model.id = response.data[0].id;
            c.getFactionStats(response.data[0].id);
          }

          c.getUserLevel();
      
        })
        .catch(function (error) {
          console.log('error')
          //console.log(error);
        });

        console.log(c.model)

    },
     getUserLevel(){
        const c = this;
     
        userService.getUserLevel()
        .then( function(response){
          c.model.userLevel = response.data[0].userLevel;


        })
        .catch(function(error){
          console.log(error)
        })
        
      },
    getSettings() {
      const c = this;
      
      let data = {};

      settingsService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.key}`] = d;
          }
          c.model.settings = data;
        })
        .catch(function (error) {
          
        });

    },
    getFactionStats(id){
      const c = this;

      // let data = {
      //   factionId : id,
      // }

      factionService.getFactionStats(id)
      .then(function (response) {
        c.model.factionStats = response.data[0];

        c.getUserFactionHistory(id);
      })
      .catch(function (error){
        console.log(error)
      })

    },
    getUserFactionHistory(id){
      const c = this;

      factionService.getFactionHistory(id)
      .then(function(response){
        c.model.userFactionHistory = response.data;
        c.fetchUserTwitchInfo();
      })
      .catch(function(error){
        console.log(error)
      })

      console.log(c.model);
    },
    closeModal() {
      const c = this;
      $('.open-faction').removeClass('is-visible');
      $('.open-faction').removeClass('is-above');
      $('.header').removeClass('z-index-zero');
        document.body.classList.remove('modal-open');
    },
    containerClicked() {
      const c = this;
      c.closeModal()
    },
    selectedFaction(id){
      const c = this;

      let data = c.model.factions[`${id}`];

      data.type='join_faction';
      data.twitchId = utils.cookies.get('user_id');

      if(data.userLevel >= c.model.settings.factionlevel.value){
        factionService.userSave(data).then(function (response) {
          if(response.data.status === 400){
            utils.alert.error(response.data.message)
          }
          c.get()
          utils.alert.success(`You’ve successfully joined ${data.name}! Please note that you won’t be able to leave or switch factions for the next ${c.model.settings.leavefaction.value} hours.`);
        })
        .catch(function(error){
          console.log(error);
        })
      }
      else{
        utils.alert.error(`Level ${c.model.settings.factionlevel.value} required`);
      }
    },
    getFactionTeam(id){
      const c = this;

      factionService.getTeam(id)
      .then(function(response){
        //c.getTwitchInfo(response.data);
        c.model.factionMembers = response.data

      })
      .catch(function(error){
        console.log(error);
      })
    },
    formatLog(log) {
      if (!log) {
        return log; // Return the original log if it's null or undefined
      }
      return log
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    getTwitchInfo(data) {
      const c = this;

      const twitchIds = data.map(item => ({ twitchId: item.twitchId }));


      twitchAPI.getUsersById(twitchIds, function(userData) {
        for (let d of userData) {
  
          let user = {
            twitchId: d.id,
            twitchDisplayName: d.display_name,
            twitchProfileImage: d.profile_image_url
          }

          const match = data.find(item => item.twitchId === user.twitchId);

          c.model.factionMembers.push(match)
          if (match) {
            // Step 5: Update the matched entry with user information
            match.twitchDisplayName = user.twitchDisplayName;
            match.twitchProfileImage = user.twitchProfileImage;
          } else {
              // data.push(user);
          }
          // c.model.champ.user.push(user);

        }
        c.model.factionMembers.sort((a, b) => {
          return a.twitchDisplayName.localeCompare(b.twitchDisplayName, undefined, { sensitivity: 'base' });
        });
      });
      
    },
    getUserTwitchInfo(id) {
      const c = this;
      return new Promise((resolve, reject) => {
          twitchAPI.getUsersById([{ twitchId: id }], function(userData, error) {
              // Check if there is an error and if it's a 400 status
              if (error && error.status === 400) {
                  // Ignore the 400 error and resolve with default values
                  resolve({
                      twitchId: id,
                      twitchDisplayName: '',
                      twitchProfileImage: ''
                  });
                  return;
              }
  
              // Check if userData is an array and has at least one valid user object
              if (Array.isArray(userData) && userData.length > 0) {
                  const user = userData[0];
  
                  // Check if the necessary properties exist and are not empty
                  if (user && user.id && user.display_name && user.profile_image_url) {
                      resolve({
                          twitchId: user.id,
                          twitchDisplayName: user.display_name,
                          twitchProfileImage: user.profile_image_url
                      });
                  } else {
                      reject({
                          twitchId: id,
                          twitchDisplayName: '',
                          twitchProfileImage: ''
                      });
                  }
              } else {
                  reject('User  not found or invalid data');
              }
          });
      });
  },
    async fetchUserTwitchInfo() {
      const c = this;
      c.loading = true;
      for (let user of c.model.userFactionHistory) {
        if (!user.opponent) {
            c.$set(c.model.userTwitchInfo, user.opponent, user);
            continue; 
        }

        try {
            const userInfo = await c.getUserTwitchInfo(user.opponent);
            c.$set(c.model.userTwitchInfo, user.opponent, userInfo);
            c.loading = false;
        } catch (error) {
          let data = {
            twitchId: user.twitchId,
            twitchDisplayName: user.opponent,
            twitchProfileImage: ''
        }
          c.$set(c.model.userTwitchInfo, user.opponent, data);
            console.error(`Error fetching info for opponent ${user.opponent}:`, error);
        }
     }
    },
    checkIfUserCanLeave(){
      const c = this;
      const joinDate = c.model.factions[c.model.id].created_at;

      const givenDate = new Date(joinDate.replace(" ", "T"));
      const now = new Date();
      const diffMs = now - givenDate;
      const hoursDiff = diffMs / (1000 * 60 * 60);
      if (hoursDiff > c.model.settings.leavefaction.value) {
        return true;
      } else {
        return false;
      }
    },
    leaveFaction(){
      const c = this;
      var result = confirm("Are you sure you want leave faction?");
      if (result === true) {
        if(!c.checkIfUserCanLeave()){
          utils.alert.error('Your allegiance is bound — you cannot abandon your faction.')
        }
        else{

          let data = {
            type :'leave_faction',
            twitchId : utils.cookies.get('user_id'),
            id: c.model.id
          }

          factionService.leave(data)
          .then(function(response){
            
            c.model.hasFaction= false
            c.model.factionMembers = [];
            c.get()
          })
          .catch(function(error){
            console.log(error);
          })

        }
      }
    },
  }
});